export default __webpack_public_path__ + "static/media/reveal.2ef941b4.gif";